var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-homepage__gallery" }, [
    _c(
      "div",
      { staticClass: "hero-homepage__gallery--wrapper" },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: index === _vm.activeIndex,
                expression: "index === activeIndex",
              },
              {
                name: "touch",
                rawName: "v-touch:swipe.right",
                value: _vm.previousSlide,
                expression: "previousSlide",
                arg: "swipe",
                modifiers: { right: true },
              },
              {
                name: "touch",
                rawName: "v-touch:swipe.left",
                value: _vm.nextSlide,
                expression: "nextSlide",
                arg: "swipe",
                modifiers: { left: true },
              },
            ],
            key: index,
            staticClass: "hero-homepage__gallery--wrapper-slide",
            class:
              index === _vm.activeIndex &&
              "hero-homepage__gallery--wrapper-slide-active",
            attrs: { "data-index": index },
          },
          [
            _c("hero-homepage-picture", {
              attrs: {
                active: index === _vm.activeIndex,
                translations: _vm.translations,
                "desktop-sizes": _vm.desktopSizes,
                item: item,
                "mobile-sizes": _vm.mobileSizes,
                "is-mobile": _vm.isSmallDevice,
                main: index === 0,
                "initial-load": _vm.initialLoad,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "hero-homepage__container" },
              [
                _c("hero-homepage-content", {
                  attrs: {
                    "cta-link-class": item.cta_link_class,
                    item: item,
                    index: index,
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "hero-homepage__gallery--controls" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNavigationButtons,
              expression: "showNavigationButtons",
            },
          ],
          staticClass:
            "hero-homepage__gallery--controls-button hero-homepage__gallery--controls-button-prev",
          attrs: { tabindex: "0" },
          on: {
            click: _vm.previousSlide,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.previousSlide.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.previousSlide.apply(null, arguments)
              },
            ],
          },
        },
        [_c("hero-homepage-arrow", { attrs: { direction: "left" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNavigationButtons,
              expression: "showNavigationButtons",
            },
          ],
          staticClass: "hero-homepage__gallery--controls-pagination",
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "button",
            {
              key: index,
              staticClass: "hero-homepage__gallery--pagination-bullet",
              class:
                index === _vm.activeIndex
                  ? "hero-homepage__gallery--pagination-bullet-active"
                  : "",
              attrs: {
                "aria-label": "Skip to slide " + (index + 1),
                role: "button",
              },
              on: {
                click: function ($event) {
                  return _vm.selectSlide(index)
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } })]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNavigationButtons,
              expression: "showNavigationButtons",
            },
          ],
          staticClass:
            "hero-homepage__gallery--controls-button hero-homepage__gallery--controls-button-next",
          attrs: { tabindex: "0" },
          on: {
            click: _vm.nextSlide,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.nextSlide.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.nextSlide.apply(null, arguments)
              },
            ],
          },
        },
        [_c("hero-homepage-arrow", { attrs: { direction: "right" } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }